import React from "react";
import { HISTORY, STATION } from "../mock";
import { Radio } from "lucide-react";

const Geschiedenis = () => {
  return (
    <div>
      <section className="relative overflow-hidden pt-40 pb-24">
        <div className="absolute -top-40 left-1/2 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-white/25 blur-3xl" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8 text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full glass-tint px-4 py-1.5 text-sm font-semibold text-white">
            <Radio className="h-4 w-4" /> Sinds 2018
          </span>
          <h1 className="mt-6 font-heading text-5xl font-extrabold text-white sm:text-6xl">Onze geschiedenis</h1>
          <p className="mx-auto mt-6 max-w-xl text-lg text-white/90">{HISTORY.intro}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <div className="relative border-l border-white/40 pl-8">
            {HISTORY.milestones.map((m, i) => (
              <div key={m.year} className="relative pb-10 last:pb-0">
                <span className="absolute -left-[41px] flex h-8 w-8 items-center justify-center rounded-full bg-white text-xs font-bold text-[#1E6BE6] shadow-lg">
                  {i + 1}
                </span>
                <div className="rounded-2xl glass p-6 transition-transform hover:-translate-y-1">
                  <span className="font-heading text-sm font-bold text-[#1E6BE6]">{m.year}</span>
                  <h3 className="mt-1 font-heading text-xl font-extrabold text-slate-900">{m.title}</h3>
                  <p className="mt-2 text-slate-500">{m.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="relative mt-10 overflow-hidden rounded-3xl bg-[#1E5FD0] p-8 text-center shadow-lg shadow-blue-900/20">
            <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-white/10 blur-2xl" />
            <p className="relative font-heading text-2xl font-extrabold text-white">En het verhaal gaat door...</p>
            <p className="relative mt-2 text-blue-100">Zet {STATION.name} aan en wees onderdeel van ons volgende hoofdstuk.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Geschiedenis;
